import React from 'react'
import styled from 'styled-components'
import Banner from './Banner'
import About from './About'
import Solutions from './Solutions'
import Skills from './Skills'
import Customers from './Customers'
import Products from './Products'
import Contact from './Contact'

const Home = () => {
  return (
    <Main id="home">
      <Banner />
      <About />
      <Solutions />
      <Skills />
      <Customers />
      <Products />
      <Contact />
    </Main>
  )
}

export default Home

const Main = styled.main``
